import * as React from "react";
import { CountBadge, Link, Spinner } from "components/common";
import usePermissions from "hooks/usePermissions";
import Routes from "routing/Routes";
import { useForwarderInputMetricsFor } from "../ForwarderInputMetricsContext";
const FAILURES_STREAM_ID = "000000000000000000000004";
const RECENT_FAILURES_RANGE_SECONDS = 15 * 60;
const failuresSearchUrl = (inputId, forwarderNodeId) => Routes.stream_search(
  FAILURES_STREAM_ID,
  // Quote both values: forwarder node IDs are UUIDs and Lucene treats `-` as NOT,
  // so a raw interpolation would parse as a different query.
  `gl2_source_input:"${inputId}" AND gl2_source_node:"${forwarderNodeId}"`,
  { relative: RECENT_FAILURES_RANGE_SECONDS }
);
const FailureCountCell = ({ input }) => {
  const { metrics, isInitialLoading, isError } = useForwarderInputMetricsFor(input.input_id, input.forwarder_node_id);
  const { isPermitted } = usePermissions();
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  const failureCount = metrics == null ? void 0 : metrics.failure_count;
  if (isError || typeof failureCount !== "number") {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": `No failure count available for input ${input.title}` }, "\u2014");
  }
  if (failureCount === 0) {
    return null;
  }
  const badgeTitle = `${failureCount} failures for input ${input.title} in the last 15 minutes`;
  const badge = /* @__PURE__ */ React.createElement(CountBadge, { count: failureCount, title: badgeTitle });
  if (!isPermitted("searches:relative") || !input.input_id || !input.forwarder_node_id) {
    return badge;
  }
  return /* @__PURE__ */ React.createElement(
    Link,
    {
      to: failuresSearchUrl(input.input_id, input.forwarder_node_id),
      title: `Search recent failures for input ${input.title}`
    },
    badge
  );
};
export default FailureCountCell;
